import { FC } from 'react';
import { Controller } from 'react-hook-form';
import { FieldTextareaProps } from './types';
import { Textarea } from 'ui/redesign/Textarea';

export const FieldTextarea: FC<FieldTextareaProps> = ({
  name,
  control,
  rules,
  label,
  errorMessage,
  onChange,
  clearErrors,
  maxLength,
  isClearable,
  inputPattern,
  ...other
}) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field }) => {
        const onChangeHandle = (value?: React.ChangeEvent<HTMLTextAreaElement>) => {
          const actualValue = value?.target.value || '';

          let filteredValue = actualValue;

          if (inputPattern) {
            const charPattern = new RegExp(inputPattern.source, 'u');
            filteredValue = Array.from(actualValue)
              .filter((char) => charPattern.test(char))
              .join('');
          }

          field.onChange(filteredValue);
          onChange?.(filteredValue);

          if (name.split('.')[2] === 'description') {
            clearErrors?.();
          }
          clearErrors?.(name);
        };
        return (
          <Textarea
            label={label}
            errorMessage={errorMessage}
            value={field.value}
            onChange={onChangeHandle}
            maxLength={maxLength}
            isClearable={isClearable}
            {...other}
          />
        );
      }}
    />
  );
};
